import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';

export default class DocumentInputs extends Component {
  @service flashMessages;

  @action
  async onChangeInputField(inputField) {
    try {
      await inputField.save();
      this.flashMessages.showAndHideFlash('success', 'Saved!');
    } catch (e) {
      this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
    }
  }
}
